module.exports = __webpack_public_path__ + "img/partner13.ee2de2ce.png";